<img src="/assets/logo/large-logo.svg" alt="background-img" class="background-img" />
<div class="container-fluid pt-4">
  <div class="row ">
    <div class="col-md-7">
      <div class="d-flex justify-content-center">
        <div class="Main-chessBoard">
          <div #boardContainer id="hijk"></div>
          <canvas id="arrowCanvas"></canvas>
        </div>
      </div>
    </div>
    @if(selectedPuzzle){
    <div class="col-md-5 complated-mobile-move">
      <div class="m-2" style="color: var(--default-font-color);cursor: pointer;width: fit-content;"  (click)="puzzleMainroute()">
        <i class="fa-solid me-1 fa-arrow-left" style="color: var(--default-font-color);font-size: 15px;"></i>Back
      </div>
      <div [ngClass]="customclassPuzzleBoard" class="complate-mobile-table" (scroll)="onScroll($event)">
        <table class="table table-striped mb-0">
          <thead class="table-light">
            <tr class="table-header table-header-sticky">
              <th scope="col">Id</th>
              <th scope="col">Themes</th>
              <th scope="col">Rating</th>
            </tr>
          </thead>
          <tbody class="border">
            @for (records of puzzleRecord; track $index) {
            <tr style="cursor: pointer" (click)="puzzleSelectID(records)">
              <td>{{ records.Index }}</td>
              <td>{{ records.Themes }}</td>
              <td>{{ records.Rating }}</td>
            </tr>
            } @if(isLoading){
            <tr>
              <td colspan="3">
                <div class="d-flex justify-content-center">
                  <p class="loader ms-3 m-0"></p>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="puzzle-move-section p-2 mt-3 mb-2 ">
        <p class="m-0 p-1 font-colors" style="word-wrap: break-word">
          {{ selectedPuzzle?.Themes }}
        </p>
        <p class="m-0 p-1 font-colors">
          {{ selectedPuzzle?.Moves }}
        </p>
        <div class="d-flex p-2">
          <button class="btn move-button" (keydown)="onKeyDown($event)" (click)="prevMove()">
            <i class="fa-solid fa-angle-left font-colors"></i>
          </button>
          <button class="btn ms-2 move-button" (keydown)="onKeyDown($event)" (click)="nextMove()">
            <i class="fa-solid fa-angle-right font-colors"></i>
          </button>
          <button class="btn ms-2 move-button" (keydown)="onKeyDown($event)" (click)="filpChessBoard()">
            <i class="fa-solid fa-repeat font-colors"></i>
          </button>
        </div>
      </div>
    </div>

    }@else {
    <section class="col-md-5 mt-4">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="col-sm-12 col-sm-offset-1 text-center">
              <h2 class="Profile-title mb-3">
                Looks like you haven't solved any puzzles. Dive in and have some
                fun!
              </h2>

              <a href="/puzzle" class="puzzleLInk">Solve Puzzles</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    }
  </div>
</div>